<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Movimentar Status de Ativo Externo
        </p>
      </div>
    </div>
    <div class="row col-12 q-gutter-sm q-mt-md text-brand-5 text-weight-bold">
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 items-center q-mb-sm">
        <div
          class="row col-12q-ml-md text-brand-5 text-weight-bold titulo-tabela q-mb-md"
        >
          <span>Lista de Ativos</span>
          <q-btn
            v-if="!mobile"
            :disable="selected.length == 0 || disable"
            class="q-ml-md"
            icon="add"
            :text-color="selected.length == 0 ? 'black' : 'white'"
            :color="selected.length == 0 ? 'accent' : 'primary'"
            label="Movimentar"
            no-caps
            @click="validarRespostas++"
          />
        </div>
        <div class="row col-md-12">
          <ComponenteFiltros
            :codigo="true"
            :classCodigo="'col-md col-xs-6'"
            :descricao="true"
            :classDescricao="'col-md col-xs-5'"
            :patrimonio="true"
            :classPatrimonio="'col-md col-xs-6'"
            :classGrupo="'col-md col-xs-5'"
            :subgrupo="true"
            :classSubgrupo="'col-md col-xs-6'"
            :statusMovimentacao="true"
            :classStatusMovimentacao="'col-md col-xs-5'"
            @enviarFiltro="receberFiltro"
          />
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="listaFerramentas"
        :hide-bottom="!listaFerramentas.length == 0"
        dense
        flat
        no-data-label="Nenhuma ferramenta encontrada."
        :class="{ 'my-sticky-dynamic': !mobile }"
        selection="multiple"
        v-model:selected="selected"
        :grid="mobile"
        row-key="ativoUuid"
        @request="handleRequest"
        binary-state-sort
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div
            @click="
              props.row.status == 'em_uso' ||
              props.row.status == 'em_transito' ||
              props.row.status == 'excluido'
                ? quasar.notify({
                    message:
                      'Não é possivel selecionar ativo com status Em_uso ou Em_transito.',
                    color: 'negative',
                    actions: [
                      {
                        label: 'Fechar',
                        color: 'white',
                        handler: () => {
                          /* ... */
                        },
                      },
                    ],
                  })
                : (props.selected = !props.selected)
            "
            class="q-pa-xs row col-12"
            :style="props.selected ? 'transform: scale(0.98);' : ''"
          >
            <q-card
              class="container-grid-table col-12 grid-style-transition q-mt-sm"
              :style="
                props.selected
                  ? 'transform: scale(0.98); background: #b7cdf6'
                  : ''
              "
            >
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col-7">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Código:</strong>
                      <span> {{ props.row.catalogoItem?.codigo }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Descrição:</strong>
                      <span> {{ props.row.catalogoItem?.nome }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Status:</strong>
                      <span>
                        {{
                          `${props.row.status
                            .charAt(0)
                            .toUpperCase()}${props.row.status.substring(1)}`
                        }}</span
                      >
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Patrimônio:</strong>
                      <span> {{ props.row.patrimonio }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row col-12 justify-end items-center">
                      <div class="q-mr-sm">
                        <div
                          style="
                            border: 1px solid #707070;
                            height: 60px;
                            width: 60px;
                            border-radius: 5px;
                            background-color: white;
                          "
                          class="row col-12 justify-center items-center"
                        >
                          <q-img
                            v-if="props.row.urlImagem"
                            fit="contain"
                            height="100%"
                            width="95%"
                            :src="props.row.urlImagem"
                          />
                          <q-img
                            v-else
                            fit="contain"
                            height="100%"
                            width="95%"
                            src="../../../assets/semImagem.jpg"
                          />
                        </div>
                      </div>
                      <div class="q-ml-sm">
                        <router-link
                          :to="{
                            name: 'ferramentaria-detalhe-movimentacao',
                            params: { ferramentaId: props.row.ativoUuid },
                          }"
                        >
                          <q-btn color="secondary" icon="article" round flat />
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td class="coluna-selecionar">
              <q-btn
                round
                size="10px"
                :icon="props.selected ? 'close' : 'add'"
                :color="props.selected ? 'red' : 'secondary'"
                :disable="
                  disable ||
                  props.row.status == 'em_uso' ||
                  props.row.status == 'em_transito' ||
                  props.row.status == 'excluido'
                "
                @click="props.selected = !props.selected"
              />
            </q-td>
            <q-td>{{ props.row.catalogoItem?.codigo }}</q-td>
            <q-td>{{ props.row.catalogoItem?.nome }}</q-td>
            <q-td>{{
              `${props.row.status
                .charAt(0)
                .toUpperCase()}${props.row.status.substring(1)}`
            }}</q-td>
            <q-td>{{ props.row.patrimonio }}</q-td>
            <q-td>
              <div
                style="
                  border: 1px solid #707070;
                  height: 60px;
                  width: 60px;
                  border-radius: 5px;
                "
              >
                <q-img
                  v-if="props.row.urlImagem"
                  fit="contain"
                  height="100%"
                  width="95%"
                  :src="props.row.urlImagem"
                />
                <q-img
                  v-else
                  fit="contain"
                  height="100%"
                  width="95%"
                  src="../../../assets/semImagem.jpg"
                />
              </div>
            </q-td>
            <q-td>
              <router-link
                :to="{
                  name: 'ferramentaria-detalhe-movimentacao',
                  params: { ferramentaId: props.row.ativoUuid },
                }"
              >
                <q-btn color="secondary" icon="article" round flat />
              </router-link>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <ComponenteChecklistAcessorio
      :etapa="'movimentacao_manual'"
      :verificar="validarRespostas"
      :arrayRespostas="selected"
      :respostas="respostas"
      :tela="'movimentacaoStatus'"
      :perguntas="true"
      @enviarValidacaoRespostas="rightDrawerOpen = true"
    />
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center justify-between">
            <div class="row items-center">
              <q-icon
                style="cursor: pointer"
                :name="tab === 'inicio' ? 'close' : 'arrow_back_ios'"
                class="q-mr-md"
                size="22px"
                @click="
                  tab == 'inicio' ? (rightDrawerOpen = false) : (tab = 'inicio')
                "
              />
              <span class="texto-titulo-modal">
                {{ tab == "inicio" ? "Movimentar Status" : "Anexos" }}
              </span>
            </div>
            <div class="justify-end row col-md col-lg col-xs-12 q-mt-xs">
              <div class="row col-12 col-xs-12 container-tab justify-end">
                <q-tabs v-model="tab" narrow-indicator dense align="right">
                  <q-tab
                    class="text-black"
                    no-caps
                    name="anexo"
                    label="Anexos"
                  />
                </q-tabs>
              </div>
            </div>
          </div>
        </div>
        <q-scroll-area v-if="tab == 'inicio'" style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md text-weight-bold">
              <div class="col-12 container-ferramenta-selecionada">
                <div class="titulo-ferramenta-selecionada">
                  Ferramentas Selecionadas
                </div>
                <div
                  class="q-mt-xs conteudo-ferramenta-selecionada"
                  v-for="(ferramenta, index) in selected"
                  :key="index"
                >
                  <div v-if="ferramenta?.catalogoItem.codigo?.length < 35">
                    <span>
                      {{ index + 1 }} - Código:
                      {{ ferramenta?.catalogoItem.codigo }}</span
                    >
                  </div>
                  <div v-else>
                    <span>
                      {{ index + 1 }} - Código:
                      {{
                        ferramenta?.catalogoItem.codigo?.substring(0, 35)
                      }}...</span
                    >
                    <q-tooltip>{{ ferramenta?.catalogoItem.codigo }}</q-tooltip>
                  </div>
                  <span class="row col-12"
                    >Status:
                    {{
                      ferramenta?.status === "uso"
                        ? "Em Uso"
                        : ferramenta?.status === "em_transito"
                        ? "Em Trânsito"
                        : ferramenta?.status === "desmobilizada"
                        ? "Desmobilizada"
                        : ferramenta?.status === "disponivel"
                        ? "Disponível"
                        : `${ferramenta?.status
                            .charAt(0)
                            .toUpperCase()}${ferramenta?.status?.substring(1)}`
                    }}</span
                  >
                </div>
              </div>
              <div class="col-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Status Final</div>
                <SelecaoStatus
                  @enviarStatus="receberStatus"
                  :resetar="resetarStatus"
                  :model="dado.status"
                  :externo="true"
                />
              </div>
              <div class="col-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Motivo</div>
                <q-input
                  :input-style="{ maxHeight: '150px' }"
                  outlined
                  type="textarea"
                  v-model="dado.motivo"
                />
              </div>
            </div>
            <div class="q-mt-md q-mb-sm q-px-md">
              <q-btn
                label="Movimentar"
                color="positive"
                no-caps
                icon="done"
                class="btn"
                :disable="disable"
                @click="movimentarStatus()"
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area v-else style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md text-weight-bold">
              <div class="col-12 q-mt-md q-mb-sm">
                <div class="texto-titulo-input q-mb-xs">Anexo</div>
                <div class="row items-center">
                  <q-btn
                    icon="file_upload"
                    color="primary"
                    class="btn-upload"
                    no-caps
                    label="Selecionar Arquivo"
                    @click="abrirDialogoArquivo()"
                  />
                  <span class="q-ml-xs" v-if="file != null">
                    <span v-if="mobile">
                      <span v-if="file?.length > 0">
                        <span
                          v-if="file[0]?.name.length > 20"
                          class="texto-upload"
                          >{{
                            file?.length == 1
                              ? `${file[0]?.name.substring(0, 20)}...`
                              : `${file?.length} Arquivos selecionados`
                          }}</span
                        >
                        <span v-else class="texto-upload">{{
                          file?.length == 1
                            ? file[0]?.name
                            : `${file?.length} Arquivos selecionados`
                        }}</span>
                      </span>
                      <span v-else>
                        <span class="texto-upload"
                          >{{ file[0]?.name.substring(0, 20) }}...</span
                        >
                        <q-tooltip>{{ file[0]?.name }}</q-tooltip>
                      </span>
                    </span>
                    <span v-else>
                      <span v-if="file?.length > 0">
                        <span
                          v-if="file[0]?.name.length > 22"
                          class="texto-upload"
                          >{{
                            file?.length == 1
                              ? `${file[0]?.name.substring(0, 20)}...`
                              : `${file?.length} Arquivos selecionados`
                          }}</span
                        >
                        <span v-else class="texto-upload">{{
                          file?.length == 1
                            ? file[0]?.name
                            : `${file?.length} Arquivos selecionados`
                        }}</span>
                      </span>
                      <span v-else>
                        <span class="texto-upload"
                          >{{ file[0]?.name.substring(0, 20) }}...</span
                        >
                        <q-tooltip>{{ file[0]?.name }}</q-tooltip>
                      </span>
                    </span>
                  </span>
                  <span v-else class="q-ml-xs texto-upload"
                    >Nenhum Arquivo Selecionado</span
                  >
                </div>
              </div>
              <div class="col-12 q-mt-md q-mb-md">
                <div class="titulo-ferramenta-selecionada">
                  Anexos Selecionados
                </div>
                <div
                  class="q-mt-xs conteudo-ferramenta-selecionada container-ferramenta-selecionada"
                  v-for="(anexo, index) in file"
                  :key="index"
                >
                  <div class="row col-12 items-center">
                    <div class="col-8">
                      <div v-if="anexo?.name.length < 35">
                        <span> {{ anexo?.name }}</span>
                      </div>
                      <div v-else>
                        <span> {{ anexo?.name.substring(0, 35) }}...</span>
                        <q-tooltip>{{ anexo?.name }}</q-tooltip>
                      </div>
                    </div>
                    <div class="row col-4 justify-end">
                      <q-btn
                        color="red"
                        flat
                        icon="delete"
                        round
                        @click="removerAnexo(index)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <q-page-sticky v-if="mobile" position="bottom-left" :offset="[18, 18]">
      <q-btn
        :text-color="selected.length == 0 ? 'black' : 'white'"
        :color="selected.length == 0 ? 'accent' : 'primary'"
        fab
        icon="add"
        :disable="selected.length == 0"
        @click="validarRespostas++"
      />
    </q-page-sticky>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";
import { setupConfiguracao } from "../composables/setupConfiguracao";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoStatus from "../components/SelecaoStatus.vue";
import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import ComponenteChecklistAcessorio from "../components/ComponenteChecklistAcessorio.vue";

const columns = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: true,
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    sortable: true,
  },
  {
    name: "status",
    label: "Status",
    align: "left",
    sortable: true,
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
    sortable: true,
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
  },
  {
    name: "detalhe",
    label: "Detalhe",
    align: "left",
  },
];

export default {
  components: {
    ListaUnidadesSelect,
    SelecaoStatus,
    ComponenteFiltros,
    ComponenteChecklistAcessorio,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let rightDrawerOpen = ref(false);
    const catalogoUuid = salvarCatalogoUuid();
    const listaFerramentas = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    const urlAnexo = ref("");
    const selected = ref([]);
    const valorOrdenacao = ref("");
    const igual = ref(false);
    const file = ref(null);
    const anexos = ref([]);
    const fileArray = ref([]);
    const fileInputRef = ref(null);
    const configuracoesSetup = setupConfiguracao();
    let loading = ref(false);
    const respostas = ref({});
    const validarRespostas = ref(0);
    const tab = ref("inicio");
    const dado = ref({
      motivo: "",
      status: "",
    });
    const filtros = ref({});
    const options = ref({
      status: [
        { label: "Em Uso", value: "uso" },
        { label: "Disponível", value: "disponivel" },
        { label: "Desmobilizada", value: "desmobilizada" },
      ],
    });
    const resetarStatus = ref(0);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarFerramenta = async (
      page = 1,
      rowsPerPage = 10,
      ordenacao = { nome: "desc" }
    ) => {
      await store.state.org.unidadeData.id;
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          ordenacao: ordenacao,
          perPage: rowsPerPage,
          page: page,
          unidadeId: store.state.org.unidadeData.id,
          comCheckLists: "sim",
          comAcessorios: "sim",
          catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
          codigo: filtros.value?.codigo,
          patrimonio: filtros.value?.patrimonio,
          nome: filtros.value?.descricao,
          nomeGrupo: filtros.value?.grupo?.nome,
          status: filtros.value?.statusMovimentacao?.status,
          nomeSubgrupo: filtros.value?.subgrupo?.nome,
          comFornecedorAlocado: "sim",
        });
        listaFerramentas.value = response.response.data.resultado.dados;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };

    const movimentarStatus = async () => {
      let ativos = [];
      if (dado.value.status == "" || dado.value.status == undefined) {
        quasar.notify({
          message: "Selecione o status.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      selected.value.forEach((atv) => {
        ativos.push({ ativoUuid: atv.ativoUuid });
      });
      if (file.value != null) {
        await buscarUrlUploadAnexo();
      }
      try {
        await store.dispatch("ferramentaria/movimentarStatusAtivo", {
          novoStatus: dado.value.status.status,
          motivo: dado.value.motivo,
          anexos: anexos.value,
          ativos: ativos,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
          movimentarAtivoExterno: true,
        });
        rightDrawerOpen.value = false;
        resetVariaveis();
        listarFerramenta();
        quasar.notify({
          message: "Status do(s) ativo(s) alterado(s) com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        if (error.response.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const abrirDialogoArquivo = () => {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.style.display = "none";
      fileInput.setAttribute("multiple", "");
      fileInput.addEventListener("change", handleFileChange);
      document.body.appendChild(fileInput);
      fileInput.click();
    };

    const handleFileChange = (event) => {
      file.value = event.target.files;
      event.target.removeEventListener("change", handleFileChange);
      event.target.remove();
    };

    const resetVariaveis = () => {
      dado.value = {
        motivo: "",
        status: "",
      };
      selected.value = [];
      file.value = null;
      urlAnexo.value = "";
      fileArray.value = [];
      anexos.value = [];
    };

    const receberStatus = (value) => {
      dado.value.status = value;
    };

    const receberConfiguracoesSetup = () => {
      if (configuracoesSetup.dadoSetupAutenticacao.value.length === 0) {
        return;
      }
      let array = configuracoesSetup.dadoSetupAutenticacao.value.filter(
        (setup) => setup.etapa === "edicao_manual"
      );
      respostas.value = {
        responderCheckLists: array[0].responderCheckLists,
        responderAcessorios: array[0].responderAcessorios,
      };
    };

    const receberGrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.grupo = "";
        return;
      }
      filtros.value.grupo = value;
    };

    const receberSubgrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.subgrupo = "";
        return;
      }
      filtros.value.subgrupo = value;
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarFerramenta();
    };

    const removerAnexo = (indice) => {
      fileArray.value = Array.from(file.value);
      fileArray.value.splice(indice, 1);
      file.value = fileArray.value;
    };

    const buscarUrlUploadAnexo = async () => {
      anexos.value = [];
      for (let i = 0; i < file.value.length; i++) {
        try {
          const response = await store.dispatch(
            "ferramentaria/buscarUrlUploadMovimentacao",
            {
              nomeArquivo: file.value[i].name,
            }
          );
          let formAttributes = response.data.resultado.dados.formAttributes;
          let formInputs = response.data.resultado.dados.formInputs;
          const formData = new FormData();

          for (let input in formInputs) {
            formData.append(input, formInputs[input]);
          }
          formData.append("file", file.value[i]);
          var request = new XMLHttpRequest();
          request.open(formAttributes.method, formAttributes.action);
          request.send(formData);
          anexos.value.push({
            urlAnexo: `${formAttributes.action}/${formInputs.key}`,
          });
        } catch (error) {
          console.log(error);
        }
      }
    };

    watch(
      () => configuracoesSetup.dadoSetupAutenticacao.value,
      () => {
        receberConfiguracoesSetup();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFerramenta(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        listarFerramenta();
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value == false) {
          tab.value = "inicio";
        }
      }
    );

    onMounted(() => {
      listarFerramenta();
      receberConfiguracoesSetup();
    });
    const handleRequest = async (value) => {
      const ordenacao = {};

      if (valorOrdenacao.value == value.pagination.sortBy) {
        igual.value = !igual.value;
        ordenacao[
          valorOrdenacao.value == "descricao" ? "nome" : valorOrdenacao.value
        ] = igual.value ? "asc" : "desc";

        pagination.value.sortBy = valorOrdenacao.value;
        pagination.value.descending = igual.value ? false : true;

        listarFerramenta(
          pagination.value.page,
          pagination.value.rowsPerPage,
          ordenacao
        );
        return;
      }

      igual.value = false;

      valorOrdenacao.value = value.pagination.sortBy;
      pagination.value.sortBy = valorOrdenacao.value;
      pagination.value.descending = true;

      ordenacao[
        valorOrdenacao.value == "descricao" ? "nome" : valorOrdenacao.value
      ] = "desc";

      listarFerramenta(
        pagination.value.page,
        pagination.value.rowsPerPage,
        ordenacao
      );
    };
    return {
      handleRequest,
      columns,
      listaFerramentas,
      disable,
      selected,
      pagination,
      removerAnexo,
      rightDrawerOpen,
      receberGrupoFiltro,
      receberSubgrupoFiltro,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      movimentarStatus,
      options,
      dado,
      resetVariaveis,
      mobile,
      quasar,
      receberStatus,
      resetarStatus,
      fileInputRef,
      file,
      loading,
      filtros,
      tab,
      receberConfiguracoesSetup,
      respostas,
      validarRespostas,
      urlAnexo,
      anexos,
      abrirDialogoArquivo,
      catalogoUuid,
      receberFiltro,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
tbody tr .coluna-selecionar {
  width: 40px !important;
  margin: 0px;
  padding: 3px 2px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal {
  height: 90%;
}
.container-ferramenta-selecionada {
  border: 1px solid black;
  padding: 10px;
  border-radius: 10px;
}
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.grid-style-transition {
  transition: transform 0.28s, background-color 0.28s;
}
.texto-titulo-modal {
  font-size: 16px;
}
.mobile {
  display: none;
}
.titulo-ferramenta-selecionada {
  font-size: 15px;
}
.conteudo-ferramenta-selecionada {
  font-size: 14px;
}
.texto-upload {
  font-size: 14px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-titulo-modal {
    font-size: 14px !important;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .titulo-ferramenta-selecionada {
    font-size: 13px;
  }
  .conteudo-ferramenta-selecionada {
    font-size: 12px;
  }
  .texto-upload {
    font-size: 9px;
  }
  .btn-upload {
    font-size: 11px;
  }
  .btn {
    font-size: 13px;
  }
}
</style>
